module.exports = __webpack_public_path__ + "static/img/images5.04b0c83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/images5.png
// module id = O8hG
// module chunks = 37